import rg4js from 'raygun4js';
import { isProduction, env } from '@/utils/shared/env';
import type { ErrorContext } from './types';

export function reportError(error: Error, context: ErrorContext): void {
    if (!isProduction) return;

    rg4js('send', {
        error,
        customData: {
            ...context,
            page: window.location.pathname,
            fullUrl: window.location.href,
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            viewport: `${window.innerWidth}x${window.innerHeight}`,
            realm: env.VITE_REALM,
        },
    });
}
